import { Button } from "../../../components/ui/Button";
import { useTranslation } from "../../../lib/i18n";
import { useDataTranslation } from "../../../lib/i18n/data";
import { Look } from "../data/types";
import { ProductCard } from "../../../app/looks-gallery/looks-gallery/ProductCard";

interface LookDetailsProps {
  selectedLook: Look;
  isVideoPlaying: boolean;
  setIsVideoPlaying: (isVideoPlaying: boolean) => void;
}

export const LookDetails = ({
  selectedLook,
  isVideoPlaying,
  setIsVideoPlaying,
}: LookDetailsProps) => {
  const { t } = useTranslation();
  const { tData } = useDataTranslation();

  return (
    <div className="flex flex-col gap-4 items-center w-full">
      <Button onClick={() => setIsVideoPlaying(!isVideoPlaying)}>
        <p className="px-4">{t('playVideo')}</p>
      </Button>
      <div className="flex p-4 rounded-[2px] bg-[rgba(5,5,5,0.20)] backdrop-blur-xl w-full flex-col gap-4">
        <div className="flex flex-col items-center w-full">
          <p className="text-white text-center font-garamond-italic text-base font-normal leading-tight">
            {t('looksGallery.christianLouboutin')}
          </p>
          <h1 className="text-white text-center font-bebas-kai text-[32px] font-normal leading-tight">
            {tData('looks', selectedLook.id, 'title', selectedLook.title)}
          </h1>
        </div>
        <div className="flex overflow-x-auto gap-4 w-full justify-evenly">
          {selectedLook.products.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      </div>
    </div>
  );
};
